<template>
  <div>
    <div class="application">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="list">
        <div class="module">
          <div class="title" v-jump="'/application/application1'">智慧园区可视化管理</div>
          <div
            class="p"
          >建立基于BIM、GIS、VR可视化技术和物联网技术的精细化运营管理平台。以运营数据管理平台为数据支撑，通过三维场景展示3DGIS和建筑BIM模型，同时将3DGIS、BIM模型管理……</div>
          <div class="btn" v-jump="'/application/application1'">了解更多</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application2'">智慧社区可视化管理</div>
          <div
            class="p"
          >依托二三维GIS地理信息技术、VR全景技术，做到城市网格之间衔接无缝隙，从而达到管理区域无缝隙。在摸清城市网格内人、事、地、物、情的各类信息情况下，通过各子系统的集成辅助……</div>
          <div class="btn" v-jump="'/application/application2'">查看详情</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application3'">智慧旅游可视化管理</div>
          <div
            class="p"
          >景点地图标注、景点VR游览、游览路线可视化、公共服务设施管理、景区客流量统计分析、消防设备可视化管理、景区管理辅助决策等。通过智慧旅游建设，提高旅游生态环境检测和保护的能力……</div>
          <div class="btn" v-jump="'/application/application3'">查看详情</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application4'">商业地产大数据可视化分析</div>
          <div class="p">臻图商场室内可视化平台包含商场单元可视化分析系统、商场客流分析系统、公寓前台管理系统、日常经营分析系统，其中商场单元可视化分析系统是对商场内店铺……</div>
          <div class="btn" v-jump="'/application/application4'">查看详情</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application5'">智慧安防可视化管理</div>
          <div
            class="p"
          >可视化应急指挥系统是基于先进GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合，软硬件结合的应急保障技术系统……</div>
          <div class="btn" v-jump="'/application/application5'">查看详情</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application6'">应急指挥可视化管理</div>
          <div
            class="p"
          >可视化应急指挥系统是基于先进GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合，软硬件结合的应急保障技术系统……</div>
          <div class="btn" v-jump="'/application/application6'">查看详情</div>
        </div>
        <template v-if="page>=2">
          <div class="module">
            <div class="title" v-jump="'/application/application7'">智慧校园可视化管理</div>
            <div
              class="p"
            >基于GIS、BIM、物联网技术，实现校园的学生管理的定位安全、招生、迎新、教务等功能，协同办公、项目管理、资产管理、设备管理、管线管理、教室房屋管理、校车管理等功能。</div>
            <div class="btn" v-jump="'/application/application7'">查看详情</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application8'">智慧城管系统</div>
            <div
              class="p"
            >数字化城管模式，是现代化城市管理的一种新模式，是把城市管理和信息技术融合在一起如GIS、移动APP、物联网等，采用网格划分和事件管理、部件管理等方式，对管理对象进行标准化……</div>
            <div class="btn" v-jump="'/application/application8'">查看详情</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application9'">智慧管网可视化管理</div>
            <div
              class="p"
            >城市综合管廊监控管理平台采用了二三维一体化的技术：在二维GIS地图的层面，平台可以监控和管理管廊分布、人员定位、巡检路线、设备报警、运行状态等;而在三维GIS地图层面则实现了……</div>
            <div class="btn" v-jump="'/application/application9'">查看详情</div>
          </div>
          <div class="module" v-jump="'/application/application10'">
            <div class="title">智慧港口可视化管理</div>
            <div
              class="p"
            >基于二三维GIS、BIM、物联网技术实现港口区域环境和设备设施的二三维可视化一张图，物联网设备信息数据集成，实现船舶管理、泊位管理、货物监管、人员监管、考勤管理、告警管理……</div>
            <div class="btn" v-jump="'/application/application10'">查看详情</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application11'">智慧停车可视化管理</div>
            <div
              class="p"
            >平台实现了包括用户管理、预约管理、订单管理；车位管理、车锁控制、实时定位、轨迹查询、路线导航、停车收费；停车诱导、计时计费、车牌识别、道闸控制等相关功能……</div>
            <div class="btn" v-jump="'/application/application11'">查看详情</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application12'">智慧电网输配电管理信息系统</div>
            <div
              class="p"
            >基于输配电管理/电力规划解决方案，用户可以在电子地图上方便直观地查看杆塔、电缆和变电站等电力设施在空间位置上的分布情况，能够方便直观地实现多元查 询统计、供电范围分析……</div>
            <div class="btn" v-jump="'/application/application12'">查看详情</div>
          </div>
        </template>
        <template v-if="page>=3">
          <div class="module">
            <div class="title" v-jump="'/application/application13'">智慧化工厂可视化系统</div>
            <div
              class="p"
            >基于三维GIS、BIM、VR技术，对化工厂区进行三维建模，对重点设备设施重大危险源等进行BIM数据可视化，结合园区视频监控和告警传感信息，为化工园区建立全景和细部三维可视化管理视图……</div>
            <div class="btn" v-jump="'/application/application13'">查看详情</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application14'">安全生产监督管理系统</div>
            <div
              class="p"
            >基于三维二三维GIS、BIM、GPS、物联网等技术，建立安全生产风险监控预警，对风险点和危险源建立数据库和电子地图，按照“分区域、分级别、网格化”管理来掌握城市风险现状……</div>
            <div class="btn" v-jump="'/application/application14'">查看详情</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application15'">智慧监狱可视化管理</div>
            <div
              class="p"
            >三维监狱管理系统需对于监狱内外建立三维立体图，并可在指挥中心的大屏上实时显示监狱管理局或下属各监狱的实时布防图和实时监控图像，在三维电子地图上显示有布防区域、摄像机位置……</div>
            <div class="btn" v-jump="'/application/application15'">查看详情</div>
          </div>
        </template>
      </div>
      <div class="more" v-if="page!=3" @click="page=page+1">加载更多</div>
    </div>
    <div class="mobile-application">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <div class="list">
        <div class="module">
          <div class="title" v-jump="'/application/application1'">智慧园区可视化管理</div>
          <div
            class="p"
          >建立基于BIM、GIS、VR可视化技术和物联网技术的精细化运营管理平台。以运营数据管理平台为数据支撑，通过三维场景展示3DGIS和建筑BIM模型，同时将3DGIS、BIM模型管理……</div>
          <div class="btn" v-jump="'/application/application1'">了解更多</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application2'">智慧社区可视化管理</div>
          <div
            class="p"
          >依托二三维GIS地理信息技术、VR全景技术，做到城市网格之间衔接无缝隙，从而达到管理区域无缝隙。在摸清城市网格内人、事、地、物、情的各类信息情况下，通过各子系统的集成辅助……</div>
          <div class="btn" v-jump="'/application/application2'">了解更多</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application3'">智慧旅游可视化管理</div>
          <div
            class="p"
          >景点地图标注、景点VR游览、游览路线可视化、公共服务设施管理、景区客流量统计分析、消防设备可视化管理、景区管理辅助决策等。通过智慧旅游建设，提高旅游生态环境检测和保护的能力……</div>
          <div class="btn" v-jump="'/application/application3'">了解更多</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application4'">商业地产大数据可视化分析</div>
          <div class="p">臻图商场室内可视化平台包含商场单元可视化分析系统、商场客流分析系统、公寓前台管理系统、日常经营分析系统，其中商场单元可视化分析系统是对商场内店铺……</div>
          <div class="btn" v-jump="'/application/application4'">了解更多</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application5'">智慧安防可视化管理</div>
          <div
            class="p"
          >可视化应急指挥系统是基于先进GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合，软硬件结合的应急保障技术系统……</div>
          <div class="btn" v-jump="'/application/application5'">了解更多</div>
        </div>
        <div class="module">
          <div class="title" v-jump="'/application/application6'">应急指挥可视化管理</div>
          <div
            class="p"
          >可视化应急指挥系统是基于先进GIS地理信息系统、GPS全球定位系统、RS遥感遥测系统、无线通讯系统、电视会议系统等和应急信息资源的多网整合，软硬件结合的应急保障技术系统……</div>
          <div class="btn" v-jump="'/application/application6'">了解更多</div>
        </div>
        <template v-if="page>=2">
          <div class="module">
            <div class="title" v-jump="'/application/application7'">智慧校园可视化管理</div>
            <div
              class="p"
            >基于GIS、BIM、物联网技术，实现校园的学生管理的定位安全、招生、迎新、教务等功能，协同办公、项目管理、资产管理、设备管理、管线管理、教室房屋管理、校车管理等功能。</div>
            <div class="btn" v-jump="'/application/application7'">了解更多</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application8'">智慧城管系统</div>
            <div
              class="p"
            >数字化城管模式，是现代化城市管理的一种新模式，是把城市管理和信息技术融合在一起如GIS、移动APP、物联网等，采用网格划分和事件管理、部件管理等方式，对管理对象进行标准化……</div>
            <div class="btn" v-jump="'/application/application8'">了解更多</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application9'">智慧管网可视化管理</div>
            <div
              class="p"
            >城市综合管廊监控管理平台采用了二三维一体化的技术：在二维GIS地图的层面，平台可以监控和管理管廊分布、人员定位、巡检路线、设备报警、运行状态等;而在三维GIS地图层面则实现了……</div>
            <div class="btn" v-jump="'/application/application9'">了解更多</div>
          </div>
          <div class="module" v-jump="'/application/application10'">
            <div class="title">智慧港口可视化管理</div>
            <div
              class="p"
            >基于二三维GIS、BIM、物联网技术实现港口区域环境和设备设施的二三维可视化一张图，物联网设备信息数据集成，实现船舶管理、泊位管理、货物监管、人员监管、考勤管理、告警管理……</div>
            <div class="btn" v-jump="'/application/application10'">了解更多</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application11'">智慧停车可视化管理</div>
            <div
              class="p"
            >平台实现了包括用户管理、预约管理、订单管理；车位管理、车锁控制、实时定位、轨迹查询、路线导航、停车收费；停车诱导、计时计费、车牌识别、道闸控制等相关功能……</div>
            <div class="btn" v-jump="'/application/application11'">了解更多</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application12'">智慧电网输配电管理信息系统</div>
            <div
              class="p"
            >基于输配电管理/电力规划解决方案，用户可以在电子地图上方便直观地查看杆塔、电缆和变电站等电力设施在空间位置上的分布情况，能够方便直观地实现多元查 询统计、供电范围分析……</div>
            <div class="btn" v-jump="'/application/application12'">了解更多</div>
          </div>
        </template>
        <template v-if="page>=3">
          <div class="module">
            <div class="title" v-jump="'/application/application13'">智慧化工厂可视化系统</div>
            <div
              class="p"
            >基于三维GIS、BIM、VR技术，对化工厂区进行三维建模，对重点设备设施重大危险源等进行BIM数据可视化，结合园区视频监控和告警传感信息，为化工园区建立全景和细部三维可视化管理视图……</div>
            <div class="btn" v-jump="'/application/application13'">了解更多</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application14'">安全生产监督管理系统</div>
            <div
              class="p"
            >基于三维二三维GIS、BIM、GPS、物联网等技术，建立安全生产风险监控预警，对风险点和危险源建立数据库和电子地图，按照“分区域、分级别、网格化”管理来掌握城市风险现状……</div>
            <div class="btn" v-jump="'/application/application14'">了解更多</div>
          </div>
          <div class="module">
            <div class="title" v-jump="'/application/application15'">智慧监狱可视化管理</div>
            <div
              class="p"
            >三维监狱管理系统需对于监狱内外建立三维立体图，并可在指挥中心的大屏上实时显示监狱管理局或下属各监狱的实时布防图和实时监控图像，在三维电子地图上显示有布防区域、摄像机位置……</div>
            <div class="btn" v-jump="'/application/application15'">了解更多</div>
          </div>
        </template>
      </div>
      <div class="more" v-if="page!=3" @click="page=page+1">
        <p>查看更多</p>
        <div>
          <i class="el-icon-arrow-down"></i>
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Application",
  metaInfo: {
    title:
      "行业应用_智慧城市和物联网空间信息可视化行业解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "智慧城市可视化,智慧园区可视化,智慧社区可视化,智慧安防可视化,智慧校园可视化,应急指挥可视化,智慧管网可视化,智慧旅游可视化,智慧港口可视化,智慧停车可视化,智慧安监可视化,智慧化工可视化,商业地产可视化,智慧电力"
      },
      {
        name: "description",
        content:
          "为智慧城市和物联网行业信息化建设提供基于空间信息三维可视化的一张图综合管理解决方案,以时空信息可视化和时空大数据分析技术为智慧城市各垂直行业信息化赋能。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "行业应用",
        p:
          "为智慧城市和物联网行业信息化建设提供基于空间信息三维可视化的一张图综合管理解决方案，以时空信息可视化和时空大数据分析技术为智慧城市各垂直行业信息化赋能。"
      },
      develop: {
        title: "更多应用",
        subtitle: "MORE",
        bgType: false
      },
      page: 1
    };
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../assets/images/application/banner.jpg");
}
.application {
  .list {
    // overflow: hidden;
    margin-bottom: 50px;
    .module {
      height: 493px;
      box-sizing: border-box;
      margin-top: 100px;
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      position: relative;
      .title {
        font-size: 30px;
        color: rgba(75, 75, 75, 1);
        margin: 70px 0 20px 0;
        cursor: pointer;
      }
      .p {
        font-size: 16px;
        color: rgba(124, 124, 124, 1);
        line-height: 32px;
      }
      .btn {
        width: 118px;
        height: 38px;
        border-radius: 19px;
        border: 1px solid rgba(124, 124, 124, 1);
        display: inline-block;
        font-size: 14px;
        color: rgba(75, 75, 75, 1);
        line-height: 38px;
        cursor: pointer;
        text-align: center;
        position: absolute;
        bottom: 60px;
      }
      &:nth-of-type(2n + 1) {
        padding-left: 830px;
        padding-right: 60px;
      }
      &:nth-of-type(2n) {
        padding-left: 60px;
        padding-right: 830px;
      }
      @List: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15;
      .ml-loop(@list,@i:1,@val:extract(@list,@i)) when (length(@list)>=@i) {
        &:nth-child(@{val}) {
          background: url("../assets/images/application/application_img@{val}.jpg")
            no-repeat center center / 100%;
        }
        .ml-loop(@list, (@i+1));
      }
      .ml-loop(@List);
    }
  }
  .more {
    margin-bottom: 50px;
  }
}
.mobile-application {
  display: none;
  width: 100%;
  flex-direction: column;
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../assets/images/application/banner.jpg");
    background-position: 33%;
    background-size: cover;
    height: 28rem;
  }
  .list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 2rem 3rem 2rem;
    .module {
      width: 33.5rem;
      height: 22rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 3rem;
      font-family: 'Normal';
      color: #fff;
      // &:nth-of-type(1) {
      //   background: url("../assets/images/application/application_img1.jpg") no-repeat
      //     center center / 100%;
      // }
      // &:nth-of-type(2) {
      //   background: url("../assets/images/application/application_img2.jpg") no-repeat
      //     center center / 100%;
      // }
      // &:nth-of-type(3) {
      //   background: url("../assets/images/application/application_img3.jpg") no-repeat
      //     center center / 100%;
      // }
      // &:nth-of-type(4) {
      //   background: url("../assets/images/application/application_img4.jpg") no-repeat
      //     center center / 100%;
      // }
      // &:nth-of-type(5) {
      //   background: url("../assets/images/application/application_img5.jpg") no-repeat
      //     center center / 100%;
      // }
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
        
      }
      .p {
        width: 23.5rem;
        font-size: 1rem;
        font-weight: 350;
        line-height: 1.5rem;
        margin-top: 2rem;
      }
      .btn {
        width: 11.5rem;
        height: 3.2rem;
        line-height: 3.2rem;
        background: #3C80E8;
        margin-top: 2rem;
        text-align: center;
        color: #fff;
        font-size: 1.2rem;
        border: none;
        cursor: pointer;
        border-radius: 2rem;
      }
      &:nth-of-type(2n + 1) {
        background-position: 0%;
      }
      &:nth-of-type(2n) {
        background-position: 90%;
      }
      @List: 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15;
      .ml-loop(@list,@i:1,@val:extract(@list,@i)) when (length(@list)>=@i) {
        &:nth-child(@{val}) {
          background-image: url("../assets/images/application/application_img@{val}.jpg");
          background-repeat: no-repeat;
          background-size: cover
        }
        .ml-loop(@list, (@i+1));
      }
      .ml-loop(@List);
    }
  }
  .more{
    margin-bottom: 3rem;
    width: 11.5rem;
    height: 3.5rem;
    background: #3C80E8;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1.75rem;
    color: #fff;
    border: none;
    p {
      font-size: 1.2rem;
      font-weight: 350;
      line-height: 2rem;
    }
    >div {
      display: flex;
      flex-direction: column;
      height: 1.6rem;
      margin-left: 1rem;
      i {
        font-size: 1rem;
        &:nth-of-type(2) {
          margin-top: -0.6rem;
        } 
      }
    }
  }
}
@media (max-width: 1024px) {
  .application {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application.vue